// Make sure to run npm install @formspree/react
// For more help visit https://formspr.ee/react-help
import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import './forms.scss';
import ReCAPTCHA from 'react-google-recaptcha';

function ContactForm() {
  const [state, handleSubmit] = useForm("mknlqlwq");
  if (state.succeeded) {
      return <p>Thank you for contacting us. We will reply soon.</p>;
  }
  return (
    <Form onSubmit={handleSubmit}>
      <h2 id='form-title'>Contact Us</h2>
      <FormGroup>
        <Label for='email'>Email</Label>
        <Input type='email' id='email' name='email' placeholder='email@example.com' />
        <ValidationError 
          prefix="Email" 
          field="email"
          errors={state.errors}
        />
      </FormGroup>
      <FormGroup>
        <Label for='message'>Message</Label>
        <Input type='textarea' name='message' id='message'/>
        <ValidationError 
          prefix="Message" 
          field="message"
          errors={state.errors}
        />
      </FormGroup>
        <ReCAPTCHA 
          sitekey="6LeiIxUqAAAAAOtIb7QM-42IxH7iO069VlIGTfan"
          onChange={(value) => setRecaptchaValue(value)}>
        </ReCAPTCHA>
      <input type="text" name="_gotcha" style={{display:'none'}} />
      <Button className="contact-btn" type="submit" disabled={state.submitting}>
        Submit
      </Button>      
    </Form>
  );
}

export default ContactForm;
